export const exportExcel = (reportData, pathIds) => {
  try {
    import('xlsx').then((XLSX) => {
      const worksheet = XLSX.utils.aoa_to_sheet(reportData);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');
      XLSX.writeFile(
        workbook,
        `cleaning-report_org_${pathIds[1]}_location_${pathIds[2]}.xlsx`
      );
    });
  } catch (err) {
    console.error('Error creating excel report: ', err);
  }
};
